// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { randomUUID } from "./uuidUtils.common.js";
